import React, { memo, useState } from 'react';
import { WedgitTemplate } from '@components';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

function VisualizationWidget({}) {
  const [tabKey, setTabKey] = useState('Deal Timeline');

  const handleTabClick = (key) => {
    setTabKey(key);
  };

  return (
    <div className="visualization-widget-manager manage-module-wrapper">
      <Tabs type="card" activeKey={tabKey} onTabClick={handleTabClick}>
        <TabPane tab="Deal Timeline" key="Deal Timeline">
          <WedgitTemplate chartType="gantt" />
        </TabPane>
        <TabPane tab="Governance Structure" key="Governance Structure">
          <WedgitTemplate chartType="org" />
        </TabPane>
      </Tabs>
    </div>
  );
}

export default memo(VisualizationWidget);
